import axios from 'axios'
import api from './index'
/**
 *
 * @type {{}}
 */
axios.defaults.timeout = 60000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charest=utf-8'
axios.interceptors.request.use(config => {
  return config
}, err => {
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  return response
}, err => {
  return Promise.reject(err)
})
//线下
// let base = '/apis/mall'
//线上   
let base = '/mall'
export default {
  // 获取企业模板
  INITMODEL (params) {
    return api.fetch('post', `${base}/initModel`, params)
  },
  //  根据域名初始访问的企业
  GET_CMPYINFOBYREQDOMAIN (params) {
    return api.fetch('post', `${base}/getCmpyinfoByReqdomain`, params)
  },
}



// WEBPACK FOOTER //
// ./src/apis/api.js